(() => {
  if (window.HaldenProductGifts) return;

  const state = {
    giftProductIds: new Set(),
    giftVariantIds: new Set(),
    syncing: false,
    pending: false,
    timer: null,
  };

  const SELECTOR = '[data-halden-gift-products]';
  const ITEM_SELECTOR = '.halden-product-gifts__item';

  function extractGiftProductIds(cart) {
    const productIds = new Set();
    const variantIds = new Set();
    if (!cart || !Array.isArray(cart.items)) return { productIds, variantIds };

    cart.items.forEach((item) => {
      if (item?.properties?._halden_gift === 'true' && item.quantity > 0) {
        // _halden_gift_for is the qualifying WATCH, not the gift product.
        // Match the actual gift line against the configured gift variant/product.
        if (item.product_id != null) productIds.add(String(item.product_id));
        if (item.variant_id != null) variantIds.add(String(item.variant_id));
      }
    });

    return { productIds, variantIds };
  }

  function applyState(scope = document) {
    const root = scope && typeof scope.querySelectorAll === 'function' ? scope : document;
    const blocks = root.matches?.(SELECTOR) ? [root] : Array.from(root.querySelectorAll?.(SELECTOR) || []);

    blocks.forEach((block) => {
      block.querySelectorAll(ITEM_SELECTOR).forEach((item) => {
        const productId = item.dataset.giftProductId ? String(item.dataset.giftProductId) : '';
        const variantId = item.dataset.giftVariantId ? String(item.dataset.giftVariantId) : '';
        const inCart = (variantId && state.giftVariantIds.has(variantId)) ||
          (productId && state.giftProductIds.has(productId));
        item.classList.toggle('is-in-cart', Boolean(inCart));

        const status = item.querySelector('[data-gift-added-status]');
        if (status) status.hidden = !inCart;
      });
    });
  }

  async function sync() {
    if (state.syncing) {
      state.pending = true;
      return;
    }

    state.syncing = true;
    try {
      const response = await fetch(`${routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      const gifts = extractGiftProductIds(cart);
      state.giftProductIds = gifts.productIds;
      state.giftVariantIds = gifts.variantIds;
      applyState(document);
    } catch (error) {
      console.error('HALDEN product gifts:', error);
    } finally {
      state.syncing = false;
      if (state.pending) {
        state.pending = false;
        schedule(100);
      }
    }
  }

  function schedule(delay = 60) {
    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(sync, delay);
  }

  function observe() {
    const observer = new MutationObserver((mutations) => {
      let shouldApply = false;
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches?.(SELECTOR) || node.querySelector?.(SELECTOR) || node.matches?.(ITEM_SELECTOR)) {
            shouldApply = true;
          }
        });
      });
      if (shouldApply) applyState(document);
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    observe();
    applyState(document);
    schedule(10);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => schedule());
    }

    document.addEventListener('cart:updated', () => schedule());
    document.addEventListener('cart:refresh', () => schedule());
    window.addEventListener('pageshow', () => schedule());
    document.addEventListener('shopify:section:load', () => schedule());
  }

  window.HaldenProductGifts = {
    refresh: schedule,
    applyState,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
